/*
  Zooted Brandz - Retailer location data
  =====================================
  This file powers the Find Zooted retailer locator.

  HOW TO EDIT:
  - Each entry in ZOOTED_RETAILERS is one licensed Michigan retailer.
  - lat/lng: coordinates used for the map and distance sorting. Values in this
    file are city-level approximations - replace with exact coordinates from
    Google Maps (right-click a location > copy coordinates) for best accuracy.
  - products: which Zooted categories the store carries. Valid keys:
    cyber-stix, infused-pre-rolls, classic-pre-rolls, flower, baller-buckets,
    gummies, chocolate, concentrates
  - featured: true shows a Featured Retailer badge and sorts the store first.
  - Retailers can ALSO be managed without code via the Find Zooted section's
    blocks in the Theme Editor; blocks are merged with (and override) this file.

  Do not publish aggregate totals of this list on the storefront.
*/
window.ZOOTED_RETAILERS = [
  {
    "id": "blue-sky-cannabis-company-44813",
    "name": "Blue Sky Cannabis Company",
    "address": "510 Savage Rd",
    "city": "Belleville",
    "state": "MI",
    "zip": "44813",
    "phone": "",
    "website": "",
    "hours": "",
    "lat": 42.2048,
    "lng": -83.4852,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "cannabis-king-48529",
    "name": "CANNABIS KING",
    "address": "3309 Associates Dr",
    "city": "Burton",
    "state": "MI",
    "zip": "48529",
    "phone": "(810) 715-9925",
    "website": "",
    "hours": "",
    "lat": 42.9995,
    "lng": -83.6163,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "capital-dank-49015",
    "name": "CAPITAL DANK",
    "address": "160 E Columbia Ave",
    "city": "Battle Creek",
    "state": "MI",
    "zip": "49015",
    "phone": "",
    "website": "",
    "hours": "",
    "lat": 42.3211,
    "lng": -85.1797,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "cookies-new-buffalo-49117",
    "name": "COOKIES NEW BUFFALO",
    "address": "19001 US-12",
    "city": "New Buffalo",
    "state": "MI",
    "zip": "49117",
    "phone": "(269) 231-5119",
    "website": "",
    "hours": "",
    "lat": 41.7934,
    "lng": -86.7439,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "craft-leaf-49036",
    "name": "Craft Leaf",
    "address": "211 W Garfield Ave",
    "city": "Coldwater",
    "state": "MI",
    "zip": "49036",
    "phone": "(517) 227-6896",
    "website": "",
    "hours": "",
    "lat": 41.9403,
    "lng": -85.0005,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "detroit-herbal-center-48238",
    "name": "Detroit Herbal Center",
    "address": "14325 Wyoming Ave",
    "city": "Detroit",
    "state": "MI",
    "zip": "48238",
    "phone": "(313) 397-2738",
    "website": "",
    "hours": "",
    "lat": 42.3314,
    "lng": -83.0458,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "dr-a-s-re-leaf-center-rec-49112",
    "name": "Dr. A's Re-Leaf Center - Rec",
    "address": "26324 US-12",
    "city": "Edwardsburg",
    "state": "MI",
    "zip": "49112",
    "phone": "",
    "website": "",
    "hours": "",
    "lat": 41.7959,
    "lng": -86.0808,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "gatsby-cannabis-49014",
    "name": "GATSBY CANNABIS",
    "address": "15530 11 Mile Rd",
    "city": "Battle Creek",
    "state": "MI",
    "zip": "49014",
    "phone": "(269) 234-5985",
    "website": "",
    "hours": "",
    "lat": 42.3171,
    "lng": -85.1797,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "gatsby-cannabis-48073",
    "name": "GATSBY CANNABIS",
    "address": "5130 Meijer Dr",
    "city": "Royal Oak",
    "state": "MI",
    "zip": "48073",
    "phone": "",
    "website": "",
    "hours": "",
    "lat": 42.4895,
    "lng": -83.1446,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "gramz-48065",
    "name": "GRAMZ",
    "address": "100 Mclean Dr",
    "city": "Bruce Township",
    "state": "MI",
    "zip": "48065",
    "phone": "",
    "website": "",
    "hours": "",
    "lat": 42.7739,
    "lng": -83.021,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "gramz-detroit-48234",
    "name": "Gramz Detroit",
    "address": "6650 East Eight Mile Road",
    "city": "Detroit",
    "state": "MI",
    "zip": "48234",
    "phone": "",
    "website": "",
    "hours": "",
    "lat": 42.3274,
    "lng": -83.0458,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "gramz-48030",
    "name": "GRAMZ",
    "address": "22821 S Chrysler Dr",
    "city": "Hazel Park",
    "state": "MI",
    "zip": "48030",
    "phone": "(248) 629-9681",
    "website": "",
    "hours": "",
    "lat": 42.4626,
    "lng": -83.1041,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "gramz-48446",
    "name": "GRAMZ",
    "address": "10 E Genesee St",
    "city": "Lapeer",
    "state": "MI",
    "zip": "48446",
    "phone": "",
    "website": "",
    "hours": "",
    "lat": 43.0514,
    "lng": -83.3188,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "gramz-48458",
    "name": "GRAMZ",
    "address": "1327 E Frances Rd",
    "city": "Mt Morris",
    "state": "MI",
    "zip": "48458",
    "phone": "",
    "website": "",
    "hours": "",
    "lat": 43.1189,
    "lng": -83.6947,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "gramz-49093",
    "name": "GRAMZ",
    "address": "223 US-131",
    "city": "Three Rivers",
    "state": "MI",
    "zip": "49093",
    "phone": "",
    "website": "",
    "hours": "",
    "lat": 41.9439,
    "lng": -85.6325,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "green-acres-ann-arbor-48108",
    "name": "Green acres Ann Arbor",
    "address": "3438 E Ellsworth Rd",
    "city": "Ann Arbor",
    "state": "MI",
    "zip": "48108",
    "phone": "(833) 791-9333",
    "website": "",
    "hours": "",
    "lat": 42.2808,
    "lng": -83.743,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "green-acres-detroit-48228",
    "name": "Green acres Detroit",
    "address": "15514 W Warren Ave",
    "city": "Detroit",
    "state": "MI",
    "zip": "48228",
    "phone": "(313) 217-7777",
    "website": "",
    "hours": "",
    "lat": 42.3314,
    "lng": -83.0458,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "flowerbowl-detroit-48228",
    "name": "Flowerbowl Detroit",
    "address": "19533 W Warren Ave",
    "city": "Detroit",
    "state": "MI",
    "zip": "48228",
    "phone": "(313) 777-9333",
    "website": "",
    "hours": "",
    "lat": 42.3354,
    "lng": -83.0458,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "remedy-detroit-48219",
    "name": "Remedy Detroit",
    "address": "20041 W 8 Mile Rd",
    "city": "Detroit",
    "state": "MI",
    "zip": "48219",
    "phone": "(313) 636-2257",
    "website": "",
    "hours": "",
    "lat": 42.3394,
    "lng": -83.0458,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "green-acres-ecorse-48229",
    "name": "Green acres Ecorse",
    "address": "337 Southfield Rd",
    "city": "Ecorse",
    "state": "MI",
    "zip": "48229",
    "phone": "(833) 791-9333",
    "website": "",
    "hours": "",
    "lat": 42.2445,
    "lng": -83.1458,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "green-acres-inkster-48141",
    "name": "Green acres inkster",
    "address": "1444 Inkster Rd",
    "city": "Inkster",
    "state": "MI",
    "zip": "48141",
    "phone": "(833) 791-9333",
    "website": "",
    "hours": "",
    "lat": 42.2942,
    "lng": -83.3099,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "antidote-inkster-48141",
    "name": "Antidote Inkster",
    "address": "26201 Michigan Ave",
    "city": "Inkster",
    "state": "MI",
    "zip": "48141",
    "phone": "(313) 331-6644",
    "website": "",
    "hours": "",
    "lat": 42.2902,
    "lng": -83.3099,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "flower-bowl-cherry-hill-48141",
    "name": "Flower bowl cherry hill",
    "address": "315 Inkster Road",
    "city": "Inkster",
    "state": "MI",
    "zip": "48141",
    "phone": "(313) 777-9333",
    "website": "",
    "hours": "",
    "lat": 42.2942,
    "lng": -83.3099,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "green-acres-riverview-48193",
    "name": "Green acres riverview",
    "address": "20990 Fort St",
    "city": "Riverview",
    "state": "MI",
    "zip": "48193",
    "phone": "(833) 791-9333",
    "website": "",
    "hours": "",
    "lat": 42.1734,
    "lng": -83.1799,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "green-genie-redford-detroit-marijuana-dispensary-48219",
    "name": "Green Genie Redford - Detroit Marijuana Dispensary",
    "address": "24600 W McNichols Rd",
    "city": "Detroit",
    "state": "MI",
    "zip": "48219",
    "phone": "",
    "website": "",
    "hours": "",
    "lat": 42.3234,
    "lng": -83.0418,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "green-genie-redford-detroit-marijuana-dispensary-48228",
    "name": "Green Genie Redford - Detroit Marijuana Dispensary",
    "address": "20046 W Warren Ave",
    "city": "Detroit",
    "state": "MI",
    "zip": "48228",
    "phone": "",
    "website": "",
    "hours": "",
    "lat": 42.3274,
    "lng": -83.0418,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "green-pharm-menominee-48723",
    "name": "Green Pharm Menominee",
    "address": "1345 Prospect Ave",
    "city": "Caro",
    "state": "MI",
    "zip": "48723",
    "phone": "",
    "website": "",
    "hours": "",
    "lat": 43.4906,
    "lng": -83.3983,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "green-pharm-menominee-49858",
    "name": "Green Pharm Menominee",
    "address": "2121 10th St",
    "city": "Menominee",
    "state": "MI",
    "zip": "49858",
    "phone": "",
    "website": "",
    "hours": "",
    "lat": 45.1077,
    "lng": -87.6143,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "happy-days-dispensary-48161",
    "name": "Happy Days Dispensary",
    "address": "14498 Laplaisance Rd",
    "city": "Monroe",
    "state": "MI",
    "zip": "48161",
    "phone": "",
    "website": "",
    "hours": "",
    "lat": 41.9164,
    "lng": -83.3977,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "high-standard-cannabis-48838",
    "name": "High Standard Cannabis",
    "address": "1100 N Lafayette",
    "city": "Greenville",
    "state": "MI",
    "zip": "48838",
    "phone": "(616) 916-4566",
    "website": "",
    "hours": "",
    "lat": 43.1775,
    "lng": -85.2528,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "high-standard-cannabis-baria-brothers-49345",
    "name": "High Standard Cannabis (Baria Brothers)",
    "address": "5 ida red ave NW suite 42",
    "city": "Sparta",
    "state": "MI",
    "zip": "49345",
    "phone": "(616) 916-4566",
    "website": "",
    "hours": "",
    "lat": 43.1611,
    "lng": -85.7098,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "jars-cannabis-ann-arbor-48197",
    "name": "JARS Cannabis \u2013 Ann Arbor",
    "address": "3005 Packard St",
    "city": "Ann Arbor",
    "state": "MI",
    "zip": "48197",
    "phone": "(734) 489-6680",
    "website": "",
    "hours": "",
    "lat": 42.2768,
    "lng": -83.743,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "jars-cannabis-battle-creek-49014",
    "name": "JARS Cannabis \u2013 Battle Creek",
    "address": "709 E Columbia Ave",
    "city": "Battle Creek",
    "state": "MI",
    "zip": "49014",
    "phone": "(269) 234-7557",
    "website": "",
    "hours": "",
    "lat": 42.3211,
    "lng": -85.1797,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "jars-cannabis-iron-river-49915",
    "name": "JARS Cannabis - Iron River",
    "address": "420 W Railroad St",
    "city": "Caspian",
    "state": "MI",
    "zip": "49915",
    "phone": "(906) 936-3869",
    "website": "",
    "hours": "",
    "lat": 46.0655,
    "lng": -88.6293,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "jars-cannabis-center-line-48015",
    "name": "JARS Cannabis \u2013 Center Line",
    "address": "26700 Liberal St",
    "city": "Center Line",
    "state": "MI",
    "zip": "48015",
    "phone": "(810) 310-8585",
    "website": "",
    "hours": "",
    "lat": 42.4851,
    "lng": -83.0277,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "jars-cannabis-west-detroit-48221",
    "name": "JARS Cannabis \u2013 West Detroit",
    "address": "7461 W 8 Mile Rd",
    "city": "Detroit",
    "state": "MI",
    "zip": "48221",
    "phone": "(313) 998-7800",
    "website": "",
    "hours": "",
    "lat": 42.3314,
    "lng": -83.0418,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "jars-cannabis-east-detroit-48205",
    "name": "JARS Cannabis \u2013 East Detroit",
    "address": "11400 E 8 Mile Rd",
    "city": "Detroit",
    "state": "MI",
    "zip": "48205",
    "phone": "(586) 298-6440",
    "website": "",
    "hours": "",
    "lat": 42.3354,
    "lng": -83.0418,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "jars-cannabis-saugatuck-49408",
    "name": "JARS Cannabis \u2013 Saugatuck",
    "address": "6790 Just Barns Dr",
    "city": "Fennville",
    "state": "MI",
    "zip": "49408",
    "phone": "(269) 346-0420",
    "website": "",
    "hours": "",
    "lat": 42.5939,
    "lng": -86.1014,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "jars-cannabis-flint-48506",
    "name": "JARS Cannabis - Flint",
    "address": "808 S Center Rd",
    "city": "Flint",
    "state": "MI",
    "zip": "48506",
    "phone": "(810) 742-2000",
    "website": "",
    "hours": "",
    "lat": 43.0126,
    "lng": -83.6875,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "jars-cannabis-mt-morris-48504",
    "name": "JARS Cannabis \u2013 Mt Morris",
    "address": "4326 W Pierson Rd",
    "city": "Flint",
    "state": "MI",
    "zip": "48504",
    "phone": "(810) 255-3300",
    "website": "",
    "hours": "",
    "lat": 43.0086,
    "lng": -83.6875,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "jars-cannabis-grand-rapids-40th-st-49508",
    "name": "JARS Cannabis - Grand Rapids 40th St",
    "address": "925 40th St SE",
    "city": "Grand Rapids",
    "state": "MI",
    "zip": "49508",
    "phone": "(616) 931-0990",
    "website": "",
    "hours": "",
    "lat": 42.9634,
    "lng": -85.6681,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "jars-cannabis-grand-rapids-alpine-49504",
    "name": "JARS Cannabis \u2013 Grand Rapids Alpine",
    "address": "1815 Alpine Ave NW",
    "city": "Grand Rapids",
    "state": "MI",
    "zip": "49504",
    "phone": "(616) 805-9900",
    "website": "",
    "hours": "",
    "lat": 42.9594,
    "lng": -85.6681,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "jars-cannabis-hazel-park-48030",
    "name": "JARS Cannabis - Hazel Park",
    "address": "20731 Dequindre Rd",
    "city": "Hazel Park",
    "state": "MI",
    "zip": "48030",
    "phone": "(248) 247-2621",
    "website": "",
    "hours": "",
    "lat": 42.4586,
    "lng": -83.1041,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "jars-cannabis-jackson-49202",
    "name": "JARS Cannabis - Jackson",
    "address": "810 W Argyle St",
    "city": "Jackson",
    "state": "MI",
    "zip": "49202",
    "phone": "(517) 888-0533",
    "website": "",
    "hours": "",
    "lat": 42.2459,
    "lng": -84.4013,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "jars-cannabis-lansing-48911",
    "name": "JARS Cannabis \u2013 Lansing",
    "address": "6450 S Cedar St",
    "city": "Lansing",
    "state": "MI",
    "zip": "48911",
    "phone": "(517) 997-8223",
    "website": "",
    "hours": "",
    "lat": 42.7325,
    "lng": -84.5555,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "jars-cannabis-madison-heights-48071",
    "name": "JARS Cannabis - Madison Heights",
    "address": "1035 12 Mile Rd",
    "city": "Madison Heights",
    "state": "MI",
    "zip": "48071",
    "phone": "(248) 429-9055",
    "website": "",
    "hours": "",
    "lat": 42.4859,
    "lng": -83.1052,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "jars-cannabis-milan-48160",
    "name": "JARS Cannabis - Milan",
    "address": "1132 Dexter St",
    "city": "Milan",
    "state": "MI",
    "zip": "48160",
    "phone": "(734) 726-9954",
    "website": "",
    "hours": "",
    "lat": 42.0853,
    "lng": -83.6816,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "jars-cannabis-mt-clemens-48043",
    "name": "JARS Cannabis \u2013 Mt Clemens",
    "address": "101 N Groesbeck Hwy",
    "city": "Mt Clemens",
    "state": "MI",
    "zip": "48043",
    "phone": "(586) 765-0032",
    "website": "",
    "hours": "",
    "lat": 42.5973,
    "lng": -82.8779,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "jars-cannabis-mt-pleasant-48858",
    "name": "JARS Cannabis \u2013 Mt Pleasant",
    "address": "1207 E Pickard St",
    "city": "Mt Pleasant",
    "state": "MI",
    "zip": "48858",
    "phone": "(989) 572-0400",
    "website": "",
    "hours": "",
    "lat": 43.5978,
    "lng": -84.7675,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "jars-cannabis-muskegon-49441",
    "name": "JARS Cannabis \u2013 Muskegon",
    "address": "1801 Peck St",
    "city": "Muskegon",
    "state": "MI",
    "zip": "49441",
    "phone": "(231) 900-1500",
    "website": "",
    "hours": "",
    "lat": 43.2342,
    "lng": -86.2484,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "jars-cannabis-chesterfield-new-baltimore-48051",
    "name": "JARS Cannabis - Chesterfield/New Baltimore",
    "address": "51679 Gratiot Ave",
    "city": "New Baltimore",
    "state": "MI",
    "zip": "48051",
    "phone": "(586) 331-3112",
    "website": "",
    "hours": "",
    "lat": 42.6811,
    "lng": -82.7369,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "jars-cannabis-new-buffalo-exit-1-49117",
    "name": "JARS Cannabis - New Buffalo Exit 1",
    "address": "11451 O'Brien Court",
    "city": "New Buffalo",
    "state": "MI",
    "zip": "49117",
    "phone": "(269) 215-0876",
    "website": "",
    "hours": "",
    "lat": 41.7894,
    "lng": -86.7439,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "jars-cannabis-new-buffalo-us-12-49117",
    "name": "JARS Cannabis - New Buffalo US-12",
    "address": "19799 U.S. 12",
    "city": "New Buffalo",
    "state": "MI",
    "zip": "49117",
    "phone": "(269) 924-0770",
    "website": "",
    "hours": "",
    "lat": 41.7934,
    "lng": -86.7439,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "jars-cannabis-okemos-48864",
    "name": "JARS Cannabis - Okemos",
    "address": "3520 Okemos Rd",
    "city": "Okemos",
    "state": "MI",
    "zip": "48864",
    "phone": "(517) 901-1575",
    "website": "",
    "hours": "",
    "lat": 42.7223,
    "lng": -84.4275,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "jars-cannabis-owosso-48867",
    "name": "JARS Cannabis \u2013 Owosso",
    "address": "200 E Main St",
    "city": "Owosso",
    "state": "MI",
    "zip": "48867",
    "phone": "(989) 494-5155",
    "website": "",
    "hours": "",
    "lat": 42.9978,
    "lng": -84.1766,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "jars-cannabis-oxford-48371",
    "name": "JARS Cannabis \u2013 Oxford",
    "address": "1225 S Lapeer Rd",
    "city": "Oxford",
    "state": "MI",
    "zip": "48371",
    "phone": "(248) 562-7025",
    "website": "",
    "hours": "",
    "lat": 42.8248,
    "lng": -83.2647,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "jars-cannabis-port-huron-48060",
    "name": "JARS Cannabis - Port Huron",
    "address": "404 Quay St",
    "city": "Port Huron",
    "state": "MI",
    "zip": "48060",
    "phone": "(810) 815-9040",
    "website": "",
    "hours": "",
    "lat": 42.9709,
    "lng": -82.4249,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "jars-cannabis-river-rouge-48218",
    "name": "JARS Cannabis \u2013 River Rouge",
    "address": "11347 W Jefferson Ave",
    "city": "River Rouge",
    "state": "MI",
    "zip": "48218",
    "phone": "(313) 466-7888",
    "website": "",
    "hours": "",
    "lat": 42.2734,
    "lng": -83.1341,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "jars-cannabis-riverview-48193",
    "name": "JARS Cannabis - Riverview",
    "address": "18580 Fort St",
    "city": "Riverview",
    "state": "MI",
    "zip": "48193",
    "phone": "(734) 264-7564",
    "website": "",
    "hours": "",
    "lat": 42.1694,
    "lng": -83.1799,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "jars-cannabis-saginaw-48602",
    "name": "JARS Cannabis - Saginaw",
    "address": "2301 N Michigan Ave",
    "city": "Saginaw",
    "state": "MI",
    "zip": "48602",
    "phone": "(989) 259-1437",
    "website": "",
    "hours": "",
    "lat": 43.4195,
    "lng": -83.9508,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "jars-cannabis-utica-48315",
    "name": "JARS Cannabis - Utica",
    "address": "45221 Utica Park Blvd",
    "city": "Utica",
    "state": "MI",
    "zip": "48315",
    "phone": "(586) 330-4269",
    "website": "",
    "hours": "",
    "lat": 42.6261,
    "lng": -83.0335,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "jars-cannabis-wayland-49348",
    "name": "JARS Cannabis - Wayland",
    "address": "142 S Main St",
    "city": "Wayland",
    "state": "MI",
    "zip": "49348",
    "phone": "(269) 443-0215",
    "website": "",
    "hours": "",
    "lat": 42.6739,
    "lng": -85.6447,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "liberty-madison-heights-au-48015",
    "name": "Liberty Madison Heights - AU",
    "address": "25440 Sherwood Ave",
    "city": "Center Line",
    "state": "MI",
    "zip": "48015",
    "phone": "(248) 268-2767",
    "website": "",
    "hours": "",
    "lat": 42.4811,
    "lng": -83.0277,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "midtown-weedworks-llc-dba-simplyloud-48202",
    "name": "Midtown Weedworks LLC, dba SimplyLoud",
    "address": "216 E Milwaukee Ave",
    "city": "Detroit",
    "state": "MI",
    "zip": "48202",
    "phone": "",
    "website": "",
    "hours": "",
    "lat": 42.3394,
    "lng": -83.0418,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "mood-provisioning-center-au-r-000756-48015",
    "name": "Mood Provisioning Center AU-R-000756",
    "address": "24320 Sherwood Ave",
    "city": "Center Line",
    "state": "MI",
    "zip": "48015",
    "phone": "",
    "website": "",
    "hours": "",
    "lat": 42.4851,
    "lng": -83.0277,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "moses-roses-chesaning-48616",
    "name": "Moses Roses Chesaning",
    "address": "101 N. FRONT ST",
    "city": "Chesaning",
    "state": "MI",
    "zip": "48616",
    "phone": "(989) 323-2222",
    "website": "",
    "hours": "",
    "lat": 43.1848,
    "lng": -84.1147,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "moses-jackson-49203",
    "name": "Moses Jackson",
    "address": "3141 Page Avenue",
    "city": "Jackson",
    "state": "MI",
    "zip": "49203",
    "phone": "(248) 760-8614",
    "website": "",
    "hours": "",
    "lat": 42.2419,
    "lng": -84.4013,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "muha-meds-48197",
    "name": "Muha Meds",
    "address": "19 N Hamilton st Ypsilanti",
    "city": "Ypsilanti",
    "state": "MI",
    "zip": "48197",
    "phone": "(248) 977-9729",
    "website": "",
    "hours": "",
    "lat": 42.2411,
    "lng": -83.613,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "mystic-of-memphis-48041",
    "name": "Mystic Of Memphis",
    "address": "33005 BORDMAN RD",
    "city": "Memphis",
    "state": "MI",
    "zip": "48041",
    "phone": "",
    "website": "",
    "hours": "",
    "lat": 42.8959,
    "lng": -82.7688,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "olswell-cannabis-co-dispensary-adrian-49221",
    "name": "Olswell Cannabis Co. Dispensary Adrian",
    "address": "1465 W Beecher Rd",
    "city": "Adrian",
    "state": "MI",
    "zip": "49221",
    "phone": "",
    "website": "",
    "hours": "",
    "lat": 41.8975,
    "lng": -84.0372,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "premiere-provisions-49307",
    "name": "Premiere Provisions",
    "address": "714 Perry Ave",
    "city": "Big Rapids",
    "state": "MI",
    "zip": "49307",
    "phone": "(231) 629-8188",
    "website": "",
    "hours": "",
    "lat": 43.6981,
    "lng": -85.4837,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "smilez-dispensary-49010",
    "name": "SMILEZ DISPENSARY",
    "address": "400 Water St",
    "city": "Allegan",
    "state": "MI",
    "zip": "49010",
    "phone": "(269) 288-5995",
    "website": "",
    "hours": "",
    "lat": 42.5292,
    "lng": -85.8553,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "smilez-dispensary-48509",
    "name": "SMILEZ DISPENSARY",
    "address": "4186 Davison Rd",
    "city": "Burton",
    "state": "MI",
    "zip": "48509",
    "phone": "(810) 341-2910",
    "website": "",
    "hours": "",
    "lat": 42.9955,
    "lng": -83.6163,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "smilez-dispensary-49082",
    "name": "SMILEZ DISPENSARY",
    "address": "104 W Chicago St",
    "city": "Quincy",
    "state": "MI",
    "zip": "49082",
    "phone": "(517) 639-1260",
    "website": "",
    "hours": "",
    "lat": 41.9442,
    "lng": -84.8838,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "smilez-dispensary-49274",
    "name": "SMILEZ DISPENSARY",
    "address": "112 S Main St",
    "city": "Reading",
    "state": "MI",
    "zip": "49274",
    "phone": "(517) 901-0115",
    "website": "",
    "hours": "",
    "lat": 41.8395,
    "lng": -84.748,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "smilez-dispensary-49093",
    "name": "SMILEZ DISPENSARY",
    "address": "1320 Millard Rd",
    "city": "Three Rivers",
    "state": "MI",
    "zip": "49093",
    "phone": "(269) 718-3230",
    "website": "",
    "hours": "",
    "lat": 41.9399,
    "lng": -85.6325,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "smilez-dispensary-48184",
    "name": "SMILEZ DISPENSARY",
    "address": "38110 Michigan Ave",
    "city": "Wayne",
    "state": "MI",
    "zip": "48184",
    "phone": "(734) 884-4449",
    "website": "",
    "hours": "",
    "lat": 42.2814,
    "lng": -83.3863,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "smok-48507",
    "name": "SMOK",
    "address": "2101 S Dort Hwy",
    "city": "Flint",
    "state": "MI",
    "zip": "48507",
    "phone": "",
    "website": "",
    "hours": "",
    "lat": 43.0126,
    "lng": -83.6875,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "sozo-health-48089",
    "name": "Sozo Health",
    "address": "23751 Hoover Rd Suite A",
    "city": "Warren",
    "state": "MI",
    "zip": "48089",
    "phone": "(574) 276-8409",
    "website": "",
    "hours": "",
    "lat": 42.5145,
    "lng": -83.0147,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "spark-cannabis-company-48723",
    "name": "Spark Cannabis Company",
    "address": "1345 Prospect Ave",
    "city": "Caro",
    "state": "MI",
    "zip": "48723",
    "phone": "",
    "website": "",
    "hours": "",
    "lat": 43.4866,
    "lng": -83.3983,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "star-budz-provisioning-center-48503",
    "name": "Star Budz Provisioning Center",
    "address": "400 S Dort Hwy",
    "city": "Flint",
    "state": "MI",
    "zip": "48503",
    "phone": "(810) 353-6781",
    "website": "",
    "hours": "",
    "lat": 43.0166,
    "lng": -83.6875,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "star-budz-provisioning-center-48458",
    "name": "Star Budz Provisioning Center",
    "address": "11401 Saginaw St",
    "city": "Mt Morris",
    "state": "MI",
    "zip": "48458",
    "phone": "(810) 353-6781",
    "website": "",
    "hours": "",
    "lat": 43.1149,
    "lng": -83.6947,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "the-grove-centerline-48015",
    "name": "THE GROVE CENTERLINE",
    "address": "26352 Lawrence Ave",
    "city": "Centerline",
    "state": "MI",
    "zip": "48015",
    "phone": "",
    "website": "",
    "hours": "",
    "lat": 42.4851,
    "lng": -83.0277,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "the-wellflower-manistee-llc-49660",
    "name": "The Wellflower Manistee LLC",
    "address": "50 Arthur ST",
    "city": "Manistee",
    "state": "MI",
    "zip": "49660",
    "phone": "(231) 970-1855",
    "website": "",
    "hours": "",
    "lat": 44.2445,
    "lng": -86.3243,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "top-cannabis-outlet-48708",
    "name": "TOP CANNABIS OUTLET",
    "address": "108 Lafayette Ave",
    "city": "Bay City",
    "state": "MI",
    "zip": "48708",
    "phone": "",
    "website": "",
    "hours": "",
    "lat": 43.5945,
    "lng": -83.8889,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "top-cannabis-outlet-48218",
    "name": "TOP CANNABIS OUTLET",
    "address": "286 Burke Street",
    "city": "River Rouge",
    "state": "MI",
    "zip": "48218",
    "phone": "(313) 254-2182",
    "website": "",
    "hours": "",
    "lat": 42.2694,
    "lng": -83.1341,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "top-cannabis-outlet-48601",
    "name": "TOP CANNABIS OUTLET",
    "address": "3375 E Washington Rd",
    "city": "Saginaw",
    "state": "MI",
    "zip": "48601",
    "phone": "",
    "website": "",
    "hours": "",
    "lat": 43.4155,
    "lng": -83.9508,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "trap-stars-new-buffalo-49117",
    "name": "Trap Stars New Buffalo",
    "address": "13964 Grand Ave",
    "city": "New Buffalo",
    "state": "MI",
    "zip": "49117",
    "phone": "(248) 321-9762",
    "website": "",
    "hours": "",
    "lat": 41.7974,
    "lng": -86.7439,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "wildglow-cannabis-co-49969",
    "name": "WildGlow Cannabis CO",
    "address": "e23860 US-2",
    "city": "Watersmeet",
    "state": "MI",
    "zip": "49969",
    "phone": "(906)-287-0316",
    "website": "",
    "hours": "",
    "lat": 46.2691,
    "lng": -89.1793,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "bloomery-cannabis-new-buffalo-49117",
    "name": "Bloomery Cannabis - New Buffalo",
    "address": "11429 O'Brien Ct",
    "city": "New Buffalo",
    "state": "MI",
    "zip": "49117",
    "phone": "",
    "website": "",
    "hours": "",
    "lat": 41.8014,
    "lng": -86.7439,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  },
  {
    "id": "vive-cannabis-co-48211",
    "name": "Vive Cannabis Co",
    "address": "1601 E Grand Blvd",
    "city": "Detroit",
    "state": "MI",
    "zip": "48211",
    "phone": "",
    "website": "",
    "hours": "",
    "lat": 42.3234,
    "lng": -83.0378,
    "products": [
      "cyber-stix",
      "infused-pre-rolls",
      "classic-pre-rolls",
      "flower",
      "baller-buckets",
      "gummies",
      "chocolate",
      "concentrates"
    ],
    "featured": false,
    "image": ""
  }
];
